import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

import { ILinkId } from '@seb/web-design-system/core';
import { Product } from '@spartacus/core';

import '../models/augmented-spartacus-cart.model';

@Injectable({
  providedIn: 'root'
})
export class PdpNavigationService {
  constructor(private translateService: TranslateService) {}

  getActiveNavigation(product: Product): ILinkId[] {
    const links = [];
    if (!!product?.ssEditorialDescriptionTitle || !!product?.star?.title) {
      links.push({
        linkName: this.translateService.instant('pdp.sectionTitles.presentation'),
        url: 'presentation'
      });
    }
    if (product?.classifications?.length > 0) {
      links.push({
        linkName: this.translateService.instant('pdp.sectionTitles.characteristics'),
        url: 'characteristics'
      });
    }
    if (
      product?.productReferences &&
      product?.productReferences['ACCESSORIES'] &&
      product?.productReferences['ACCESSORIES'].length > 0
    ) {
      links.push({
        linkName: this.translateService.instant('pdp.sectionTitles.accessories'),
        url: 'accessories'
      });
    }
    if (product?.reviews?.length > 0) {
      links.push({ linkName: this.translateService.instant('pdp.sectionTitles.review'), url: 'review' });
    }
    return links;
  }
}
